<template>
  <Highcharts
    ref="chart"
    :options="chartOptions"
  />
</template>

<script>
import { Chart } from 'highcharts-vue';

import formatterTooltip from './formatter-tooltip.js';

export default {
  name: 'BasicBar',
  components: {
    Highcharts: Chart,
  },
  props: {
    series: {
      type: Array,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    overrideChartOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      observer: null,
    };
  },
  computed: {
    chartOptions() {
      return {
        credits: {
          enabled: false,
        },
        chart: {
          type: 'bar',
          styleMode: true,
          colorByPoint: true,
        },
        title: {
          text: '',
        },
        xAxis: {
          categories: this.categories,
          labels: {
            style: {
              color: 'var(--ds-color-text-2)',
              fontSize: 'var(--ds-font-size-xs)',
              fontWeight: 'var(--ds-font-weight-semibold)',
            },
          },
          lineWidth: 0,
          tickWidth: 0,
        },
        yAxis: {
          min: 0,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
          },
          labels: {
            enabled: false,
          },
          gridLineColor: '',
        },
        legend: {
          reversed: true,
          align: 'left',
          margin: 18,
          padding: 0,
        },
        tooltip: {
          shared: false,
          useHTML: true,
          shadow: false,
          backgroundColor: 0,
          borderWidth: 0,
          borderRadius: 0,
          formatter() {
            return formatterTooltip(this);
          },
        },
        plotOptions: {
          series: {
            stacking: 'normal',
            pointPadding: 0.01,
            events: {
              legendItemClick: (e) => {
                this.$emit('legend-click', { legend: e.target.name });
              },
            },
          },
        },
        series: this.series,
        ...this.overrideChartOptions,
      };
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .highcharts {
    &-tooltip {
      border-radius: var(--ds-border-radius-sm);

      &-box {
        stroke-width: 0;
        fill: var(--ds-color-neutral);
        stroke: var(--ds-color-neutral);
        fill-opacity: 1;
      }
    }
  }

  .tooltip-pie {
    margin: 0;
    box-shadow: var(--ds-light-dropshadow-1);
    padding: var(--ds-spacing-stack-xs);
    border-radius: var(--ds-border-radius-sm);
    background: var(--ds-color-neutral);

    &__header {
      display: flex;
      align-items: center;
    }

    &__bottom {
      margin-top: var(--ds-spacing-stack-nano);
    }

    &__point {
      border-radius: var(--ds-border-radius-pill);
      margin-right: var(--ds-spacing-stack-nano);
      padding: var(--ds-spacing-stack-quark);
    }

    &__name {
      color: var(--ds-color-text-1);
      font-size: var(--ds-font-size-xs);
      font-weight: var(--ds-font-weight-regular);
    }

    &__fans {
      color: var(--ds-color-text-1);
      font-size: var(--ds-font-size-xs);
      margin-right: var(--ds-spacing-stack-nano);
      font-weight: var(--ds-font-weight-semibold);
    }
  }
}
</style>
